import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import kebabCase from 'lodash/kebabCase'
import ServiceTile from './components/ServiceTile'

const BOTServiceCategories = ({
  description,
  title,
  serviceCategories: {
    serviceCategories = []
  } = {},
  isServicesPage
}) =>
  <React.Fragment>
    { isServicesPage
      ? <Title data-at-heading={ kebabCase(title) }>{ title }</Title>
      : <SecondaryTitle data-at-heading={ kebabCase(title) }>{ title }</SecondaryTitle>
    }
    <SubHead data-at-heading-subhead={ kebabCase(title) }>{ description }</SubHead>
    <ServiceWrapper>
      <Tiles>
        { serviceCategories.map(({ categoryName, categoryId, serviceCategorySeo, iconName }, index) =>
          <ServiceTile
            data-at-services-servicetile
            key={ index }
            categoryId={ categoryId }
            categoryName={ categoryName }
            iconName={ iconName }
            serviceCategorySeo={ serviceCategorySeo } />
        )}
      </Tiles>
    </ServiceWrapper>
  </React.Fragment>

BOTServiceCategories.propTypes = {
  description: PropTypes.string,
  isServicesPage: PropTypes.bool,
  serviceCategories: PropTypes.shape({
    nrOfServiceCategories: PropTypes.number,
    serviceCategories: PropTypes.arrayOf(PropTypes.shape())
  }),
  title: PropTypes.string
}

export default BOTServiceCategories

const Title = styled.h1`
  color: ${Theme.colors.black_new};
  text-align: center;
  text-transform: uppercase;
  margin: 25px 0;
  transform: scale(1, 1.5);
  ${Mixin.font.GothamBold(34)}
  ${Media.mobile`
    font-size: 22px;
  `}
`

const SecondaryTitle = styled.h2`
  color: ${Theme.colors.black_new};
  text-align: center;
  text-transform: uppercase;
  margin: 25px 0;
  transform: scale(1, 1.3);
  ${Mixin.font.GothamBold(24)}
  ${Media.mobile`
    font-size: 22px;
  `}
`

const Tiles = styled.div`
  text-align: center;
  ${Mixin.responsive('padding', '50px 0', '40px 0')}
`

const SubHead = styled.div`
  color: ${Theme.colors.black};
  text-align: center;
  ${Mixin.font.GothamBook(20)}
  ${Mixin.responsive('margin', '0 auto', '0 16px')}
  ${Media.mobile`
    font-size: 16px;
    line-height: 22px;
  `}
`

const ServiceWrapper = styled.div`
  ${props => props.centered && css`
    text-align: center;
  `}
`
